import {
  LuChartColumn, LuCirclePlus, LuCoins, LuCrown, LuGift, LuNetwork, LuRefreshCw, LuTicket,
  LuTrophy, LuWallet, LuZap,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
// Tab content only renders once a programme exists, so these tours wait for one.
const tours = [
  tour('loyalty', '/loyalty', 'loyalty', [
    ['tabs', 'loyalty.tabs', LuGift],
    ['create', 'loyalty.create', LuCirclePlus, opt],
    ['kpis', 'loyalty.kpis', LuChartColumn, opt],
    ['refresh', 'loyalty.refresh', LuRefreshCw, opt],
  ]),
  tour('loyalty_members', '/loyalty/members', 'loyalty', [
    ['ledger', 'loyalty_members.ledger', LuWallet],
    ['balances', 'loyalty_members.balances', LuCoins, { placement: 'top' }],
  ]),
  tour('loyalty_rules', '/loyalty/rules', 'loyalty', [
    ['rules', 'loyalty_rules.rules', LuZap, { placement: 'top' }],
    ['add', 'loyalty_rules.add', LuCirclePlus, opt],
  ]),
  tour('loyalty_tiers', '/loyalty/tiers', 'loyalty', [
    ['tiers', 'loyalty_tiers.tiers', LuCrown, { placement: 'top' }],
    ['add', 'loyalty_tiers.add', LuCirclePlus, opt],
  ]),
  tour('loyalty_rewards', '/loyalty/rewards', 'loyalty', [
    ['catalog', 'loyalty_rewards.catalog', LuGift, { placement: 'top' }],
    ['add', 'loyalty_rewards.add', LuCirclePlus, opt],
    ['vouchers', 'loyalty_rewards.vouchers', LuTicket, { placement: 'top', ...opt }],
  ]),
  tour('loyalty_referrals', '/loyalty/referrals', 'loyalty', [
    ['leaderboard', 'loyalty_referrals.leaderboard', LuTrophy, { placement: 'right' }],
    ['trees', 'loyalty_referrals.trees', LuNetwork, { placement: 'left' }],
  ]),
];

export default tours;
